import { Component, Input } from '@angular/core';
import { BcContestProbability } from '../../models/BcContest';

@Component({
    selector: 'app-bc-contest-probability',
    template: `
<span *ngIf="value"
      class="probability-bubble"
      [class.bg-success]="value == 'High'"
      [class.bg-warning]="value == 'Medium'"
      [class.bg-danger]="value == 'Low'"
      [title]="'bcContest_probability' + value | translate"></span>
`,
    styleUrls: ['./bc-contest.scss']
})
export class BcContestProbabilityComponent {
    @Input() value: BcContestProbability;
}
